import type { ITaskRepository, SearchTaskResult } from "@src/domain/pascos/repository/task_repository";
import { ListAllTasksUseCase } from "./list_all_tasks.usecase";
import { GetTaskByIdUseCase } from "./get_task_by_id.usecase";
import { UpdateTaskStatusUseCase } from "./update_task_status.usecase";
import { DeleteTaskUseCase } from "./delete_task.usecase";

/**
 * Task Service
 * Central service that aggregates all task-related use cases
 */
export class TaskService {
    // Use cases
    public readonly listAllTasks: ListAllTasksUseCase;
    public readonly getTaskById: GetTaskByIdUseCase;
    public readonly updateTaskStatus: UpdateTaskStatusUseCase;
    public readonly deleteTask: DeleteTaskUseCase;

    private readonly taskRepository: ITaskRepository;

    constructor(taskRepository: ITaskRepository) {
        this.taskRepository = taskRepository;
        this.listAllTasks = new ListAllTasksUseCase(taskRepository);
        this.getTaskById = new GetTaskByIdUseCase(taskRepository);
        this.updateTaskStatus = new UpdateTaskStatusUseCase(taskRepository);
        this.deleteTask = new DeleteTaskUseCase(taskRepository);
    }

    /**
     * List tasks with pagination
     */
    async listTasksPaginated(params: {
        status?: string;
        skip?: number;
        limit?: number;
    }): Promise<SearchTaskResult> {
        return this.taskRepository.listPaginated(params);
    }
}
